import React, { useEffect, useState } from "react";
import TopNavBar from "../../components/reusables/topNavBar";
import ClientService from "../../rest/clientService";
import { formatCNPJ, formatPhoneNumber } from "../../utils/DocumentUtils";
import { IntegrationTab } from "./components/integrationTab";

function ClientPage() {
    const [client, setClient] = useState(null);
    const [activeTab, setActiveTab] = useState('dados');

    useEffect(() => {
        ClientService.getClientInfo()
            .then(setClient)
            .catch(console.error);
    }, []);

    const Tab = ({ id, label }) => (
        <button
            onClick={() => setActiveTab(id)}
            className={`px-5 py-2 text-sm font-bold border-b-2 transition-colors ${
                activeTab === id
                    ? 'border-custom_blue text-custom_blue'
                    : 'border-transparent text-gray-400 hover:text-gray-600'
            }`}
        >
            {label}
        </button>
    );

    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Cadastro do Cliente"} subtitle={"Confira as informações de cadastro e contato da sua empresa."} />

            <div className="flex border-b border-gray-200 px-4 md:px-16 mt-2">
                <Tab id="dados" label="Dados" />
                <Tab id="integracoes" label="Integrações" />
            </div>

            {activeTab === 'dados' && (
                client ? (
                    <div className='flex items-center justify-center'>
                        <div className="w-full mx-4 md:mx-16 my-4">
                            <p className="flex text-xl text-custom_gray_font font-bold">Informações da empresa</p>
                            <div className="py-2 grid grid-cols-2 gap-x-2">
                                <div>
                                    <p className="flex text-base text-custom_gray_font font-semibold"> Nome do Cliente</p>
                                    <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.client_name}</p>
                                </div>
                                <div>
                                    <p className="flex text-base text-custom_gray_font font-semibold"> CNPJ</p>
                                    <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {formatCNPJ(client.cnpj)}</p>
                                </div>
                            </div>
                            <div className="py-2">
                                <p className="flex text-base text-custom_gray_font font-semibold">Telefone</p>
                                <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.phone_number === null || '' ? 'Não Registrado' : formatPhoneNumber(client.phone_number)}</p>
                            </div>
                            <div className="py-2">
                                <p className="flex text-base text-custom_gray_font font-semibold">Endereço</p>
                                <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.address === null || '' ? 'Não Registrado' : client.address}</p>
                            </div>
                            <div className="py-2">
                                <p className="flex text-base text-custom_gray_font font-semibold">Status</p>
                                <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.status === true ? 'Ativo' : 'Inativo'}</p>
                            </div>
                            <p className="mt-4 flex text-xl text-custom_gray_font font-bold">Contato</p>
                            <div className="py-2">
                                <p className="flex text-base text-custom_gray_font font-semibold">Pessoa para contato</p>
                                <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.contactperson === null || '' ? 'Não Registrado' : client.contactperson}</p>
                            </div>
                            <div className="py-2 grid grid-cols-2 gap-x-2">
                                <div>
                                    <p className="flex text-base text-custom_gray_font font-semibold"> Usuário para contato</p>
                                    <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.contactuser}</p>
                                </div>
                                <div>
                                    <p className="flex text-base text-custom_gray_font font-semibold"> Email para contato</p>
                                    <p className="flex w-full px-3 py-1.5 text-base font-medium text-custom_gray_font border border-solid border-gray-200 rounded"> {client.contactemail}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <p className="mx-4 md:mx-16 my-4">Nenhum cadastro encontrado.</p>
                )
            )}

            {activeTab === 'integracoes' && (
                <IntegrationTab client={client} />
            )}
        </div>
    );
}

export default ClientPage;
